import * as React from "react";
import { withRouter } from "react-router-dom";
import { Grid } from "semantic-ui-react";
// import { PasswordForgetLink } from "../PasswordForget";
// import { SignUpLink } from "../SignUp";
import { SignInForm } from "./SignInForm";

const SignInComponent = ({ history }: { [key: string]: any }) => (
  <Grid textAlign="center" className="signin-page">
    <Grid.Column style={{ maxWidth: 800 }}>
      <SignInForm history={history} />
      {/* <Message>
        <PasswordForgetLink />
        <SignUpLink />
      </Message> */}
    </Grid.Column>
  </Grid>
);

const SignIn = withRouter(SignInComponent);

export default SignIn;



// WEBPACK FOOTER //
// ./src/containers/SignIn/index.tsx